import React, { useState } from 'react'
import './FAQSection.css'

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null)

  const faqs = [
    {
      question: "What does the AMLBot check show?",
      answer: "The basic AMLBot check result includes risk score percentage, sources of risk, and belonging to the blacklist.<br><br> In addition, the check result may include various optional information about the address, such as belonging to the cluster, actual balance, and transferred funds amount.<br><br> The check result may be incomplete in relation to the described data if the necessary information is missing.<br><br> Please note that for blockchains that are in the limited mode, clustering and percentage value of the check risk score are not available. A risk score can be provided for a counterparty only if it relates to an entity."
    },
    {
      question: "What does the percentage risk score mean?",
      answer: "The overall risk score (percentage) is the probability that the address is associated with illegal activity.<br><br> AMLBot finds connections of a checked address to other addresses on the blockchain and with entities of different categories, each with a different conditional risk score, and calculates the overall risk score based on those connections.<br><br> The overall risk score calculation takes into account the risk severity of connections found. For example, in the case of connections to entity categories Mining (0% risk) and Darknet (100% risk), the risk impact of Darknet, as a more risky category, will be higher, and Mining will have less weight in the risk assessment."
    },
    {
      question: "What do the sources of risk mean?",
      answer: "AMLBot checks the specified wallet address for connections to known blockchain services - entities. AMLBot conventionally groups these services into groups with different risk levels of illegal activity - entity categories.<br><br> The AML check shows the connections of the checked address to these entity categories as the sources of risk, with which the address interacted, and the percentage of funds transferred from/to these services.<br><br> Based on all the sources of risk, an overall risk score is calculated, which helps the user to make further decisions about the assets."
    },
    {
      question: "What is the difference between an address and a transaction checks?",
      answer: "An address check is an analysis of all its connections to other addresses and entities on blockchains, considering incoming and outgoing funds movement.<br><br> A transaction check process differs from the address check, and the result depends on your side in the transaction. The overall risk score always relates to the counterparty.<br><br> To check a transaction you need to specify the TxID and the destination address of the transaction and select your side in the transaction:<br> - Recipient (you got a deposit to your wallet) - the addresses from which the funds were received are checked. The sources of risk describe the services from which the TX senders accumulated the transferred funds with a percentage breakdown.<br> - Sender (you made a withdrawal from your wallet) - the wallet that received the funds is checked. The sources of risk describe all connections of the recipient address with a percentage breakdown.<br><br> Thus, when checking a transaction, the risks for the recipient are checked if you receive funds, and the risks for the sender if you send funds."
    },
    {
      question: "How do I understand risk assessment?",
      answer: "Each client determines for himself what percentage of risk is acceptable for him. Conventionally, the risk score can be divided as follows:<br>- 0-25% is a clean wallet/transaction;<br>- 25-75% is the average level of risk;<br>- 75%+ such a wallet/transaction is considered risky.<br>It is also worth paying attention to the red sources of risk in the detailed analysis."
    },
    {
      question: "What cryptocurrencies does AMLBot analyze?",
      answer: "AMLBot supports all major blockchains and tokens on them. We are constantly adding support for additional cryptocurrencies."
    },
    {
      question: "How does AMLBot help to protect you against blocking?",
      answer: "By checking counterparties' wallets before a transaction, you can reject their assets if the risk score is high. Also, before transferring funds to other services, you can check your wallet address and save the result (make a screenshot).<br><br> If the check shows that your assets had no connection with illegal activity and the service blocked you, you can provide the saved result to confirm the purity of your assets."
    },
    {
      question: "The risk is higher than 50%, but I am certain that the address is reliable. What to do?",
      answer: "The check results are based on the international databases, which are constantly updated. So an address that had 0% risk yesterday may have received or given the asset to a risky counterparty today. In this case, the risk score will change. If you want to be sure of the result and determine what the cause of the high risk is, we can do a detailed check for you. To do it, email us at <a href=\"mailto:aml@multiscan.app\">aml@multiscan.app</a>"
    },
    {
      question: "How often are checks recommended to do?",
      answer: "An answer to this question depends on your unique risk model. The general recommendation would be to perform an AML check every time you interact with an unknown wallet or a smart contract."
    },
    {
      question: "How quickly is the balance replenished?",
      answer: "After transaction confirmation, the balance is replenished:<br> • up to 10 minutes if the payment was made within 24 hours after the invoice was issued, <br> • up to 25 minutes if the payment was made after 24 hours after the invoice issuance. Overall, BTC, ETH, USDT, and fiat are processed faster than other cryptocurrencies."
    },
    {
      question: "What happens if I don't use all my checks each month?",
      answer: "If you purchased checks without expiration date - they remain in your account, and you can use them at any time.<br><br> If you purchased checks with a time limit - they will be deducted from your account after expiration date."
    },
    {
      question: "What if I will need more checks?",
      answer: "You can buy additional checks as needed. The number of checks is always displayed within your user information."
    },
    {
      question: "How does AMLBot ensure data protection?",
      answer: "AMLBot safeguards data by adhering to rigorous standards, as validated by our ISO 9001 and ISO 27001 certifications. <br><br>Our ISO 9001 certification highlights our commitment to delivering consistent quality and enhancing customer satisfaction. More crucially, our ISO 27001 certification demonstrates our dedication to maintaining high standards of information security, ensuring the protection of sensitive data, and achieving regulatory compliance."
    }
  ]

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index)
  }

  return (
    <section className="JCqsM_" id="faq">
      <div className="b_L6f_">
        <div className="xb1dXH">
          <h2 className="dc_GNJ aos-init aos-animate" data-aos="fade-up">FAQs</h2>
        </div>
        <div className="_9SfPwg">
          <div className="_PiqMG aos-init aos-animate" data-aos="fade-up">
            <h3 className="Fl3Ugx">Is your question not on the list?</h3>
            <p className="_636_tF">
              Contact us via messenger. We are in touch <b>24/7</b>, so any issue can be resolved quickly and in a live chat format.
            </p>
            <button type="button" className="MZR5Z_">
              <div className="fWkT8f">
                <svg className="icon icon-helpcrunch" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"/>
                </svg>
              </div>
              <div className="h165hA">
                <h4>We're in messenger</h4>
                <p>We will answer within 30 seconds</p>
              </div>
            </button>
            <p className="_9yCvRy">
              <small>It may take a little longer to respond during the night.</small>
            </p>
          </div>
          <div className="e5xgXj aos-init aos-animate" data-aos="fade-up" data-aos-delay="50">
            <div>
              {faqs.map((faq, index) => (
                <div key={index} className={`_Ul5cK ${openIndex === index ? '_0P8u3K' : ''}`}>
                  <div
                    role="button"
                    className="paUd7O"
                    onClick={() => toggleFAQ(index)}
                  >
                    {faq.question}
                  </div>
                  <div
                    className="ORhlBm"
                    style={{
                      height: openIndex === index ? 'auto' : '0px',
                      transition: '0.25s'
                    }}
                  >
                    <div>
                      <div
                        className="_9ZTzQc"
                        dangerouslySetInnerHTML={{ __html: faq.answer }}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default FAQSection
